export default __webpack_public_path__ + "static/media/aim.35dbbe44.png";